import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import type {
  BroadcastSegment,
  RecipientCountResponse,
  SendBroadcastRequest,
  SendBroadcastResponse,
} from 'types/interfaces/broadcast';

export const broadcastApi = createApi({
  reducerPath: 'broadcastApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getRecipientCount: builder.query<RecipientCountResponse, BroadcastSegment>({
      query: (segment) => ({
        url: `/admin/broadcast/recipient-count?segment=${segment}`,
        method: 'GET',
        requiresAuth: true,
      }),
    }),

    sendBroadcast: builder.mutation<SendBroadcastResponse, SendBroadcastRequest>({
      query: (body) => ({
        url: '/admin/broadcast/send',
        method: 'POST',
        body,
        requiresAuth: true,
      }),
    }),
  }),
});

export const {
  useGetRecipientCountQuery,
  useSendBroadcastMutation,
} = broadcastApi;
